module.exports = __webpack_public_path__ + "img/gleeder-mobile-banner.4c70bd3a.png";